export * from './TextInput';
try {
    // @ts-ignore
    TextInputPrimitive.displayName = "TextInputPrimitive";
    // @ts-ignore
    TextInputPrimitive.__docgenInfo = { "description": "", "displayName": "TextInputPrimitive", "props": { "onChange": { "defaultValue": null, "description": "", "name": "onChange", "required": true, "type": { "name": "(e: any) => void" } }, "name": { "defaultValue": null, "description": "", "name": "name", "required": true, "type": { "name": "string" } }, "value": { "defaultValue": null, "description": "", "name": "value", "required": true, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/inputs/TextInput/index.ts#TextInputPrimitive"] = { docgenInfo: TextInputPrimitive.__docgenInfo, name: "TextInputPrimitive", path: "src/components/inputs/TextInput/index.ts#TextInputPrimitive" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    TextInput.displayName = "TextInput";
    // @ts-ignore
    TextInput.__docgenInfo = { "description": "", "displayName": "TextInput", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/inputs/TextInput/index.ts#TextInput"] = { docgenInfo: TextInput.__docgenInfo, name: "TextInput", path: "src/components/inputs/TextInput/index.ts#TextInput" };
}
catch (__react_docgen_typescript_loader_error) { }